import { render, staticRenderFns } from "./NeoparentCreateReflection.vue?vue&type=template&id=a176ade6&scoped=true"
import script from "./NeoparentCreateReflection.vue?vue&type=script&lang=js"
export * from "./NeoparentCreateReflection.vue?vue&type=script&lang=js"
import style0 from "./NeoparentCreateReflection.vue?vue&type=style&index=0&id=a176ade6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a176ade6",
  null
  
)

export default component.exports